import "./transactionDetailTableStyle.css";

import { EnhancedButtonPrimeReactSeverity, RequestParams } from "@websential/cosmic-v20";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { formatAmountCommaSeperator, formatDateToShow } from "../../../common/Common";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";

export interface IDataTable {
  rows: any;
  last_rows: any;
  columns: any;
  showIndexColumn: boolean;
  showChecboxColumn: boolean;
  showSettingColumn: boolean;
  isLoading?: boolean;
  onRequestParamsChange?: (params: RequestParams) => void;
  initialPageSize?: number | undefined;
  initialPage?: number;
  totalRecords?: number;
  searchFieldPlaceholder?: string;
  showGlobalSearch?: boolean;
}

export const TransactionDetailDataTable: React.FC<IDataTable> = ({
  rows,
  last_rows,
  columns,
  showIndexColumn,
  showChecboxColumn,
  showSettingColumn,
  // onRowPrintClicked,
  isLoading,
  // onSnackbarMessageData,
  totalRecords,

  onRequestParamsChange,
  initialPageSize = 10,
  initialPage = 0,
  searchFieldPlaceholder,
  showGlobalSearch = true,
}) => {
  const isInitialRequest = useRef(true);
  const setting = () => {
    return (
      <div>
        <i className="pi pi-cog text-xl"></i>
      </div>
    );
  };
  const printBody = (params: any) => {
    return (
      <Button
        icon="pi pi-print"
        // onClick={() =>
        //   onRowPrintClicked(selectedItems.length > 0 ? selectedItems : params)
        // }
        className="p-button-rounded p-button-text w-2rem h-2rem"
      />
    );
  };

  // this states used in the process of filteration of dataTable
  const [itemSearch, setItemSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [requestParams, setRequestParams] = useState<any>({
    first: initialPage,
    rows: initialPageSize,
    page: initialPage,
    sortField: null,
    sortOrder: "asc",
    searchQuery: "",
    filters: {
      name: { value: "", matchMode: "contains" },
      "country.name": { value: "", matchMode: "contains" },
      company: { value: "", matchMode: "contains" },
      "representative.name": { value: "", matchMode: "contains" },
    },
  });

  const [val, setValue] = useState(false)
  const [field, setField] = useState("")


  // Search type and billing profile Button
  // const renderHeader = () => {
  //   return (
  //     <div className='flex justify-content-between p-4' style={{ backgroundColor: "#ebecf0", margin: "-17px" }}>
  //       <span className="p-input-icon-left w-5">
  //         {/* <i className="pi pi-search" /> */}
  //         <InputText value={itemSearsch} onChange={(e) => setItemSearsch(e.target.value)} placeholder="Search by Employee Name" className='w-full bg-transparent' />
  //       </span>
  //       {/* <Button label='Ganeral Client List' className='p-button-success uppercase'/> */}
  //     </div>
  //   )
  // }
  // const headerSearch = renderHeader();

  const onSearchButtonClicked = () => {
    setLoading(true);
    setRequestParams((prevParams: any) => ({
      ...prevParams,
      first: initialPage,
      rows: initialPageSize,
      page: initialPage,
      searchQuery: itemSearch,
    }));
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const handleClearSearch = () => {
    setLoading(true);
    setItemSearch("");
    setRequestParams((prevParams: any) => ({
      ...prevParams,
      first: initialPage,
      rows: initialPageSize,
      page: initialPage,
      searchQuery: "",
    }));
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const renderHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",

        }}
      >
        {showGlobalSearch && (
          <span
            className="p-input-icon-left w-3"
            style={{
              display: "flex",
              marginLeft: "auto",
              marginRight: "1rem",
              height: "37px",
              maxWidth: "250px",
            }}
          >
            <i className="pi pi-search" />
            <InputText
              value={itemSearch}
              onChange={(e) => setItemSearch(e.target.value)}
              placeholder={
                searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
              }
              className="w-full"
              style={{ borderRadius: "2px 0px 0px 2px" }}
            />
            {itemSearch && (
              <Button
                icon="pi pi-times"
                onClick={handleClearSearch}
                className="p-button-warning"
                style={{ borderRadius: 0, }}
              />
            )}
            <Button
              onClick={onSearchButtonClicked}
              severity={EnhancedButtonPrimeReactSeverity.Secondary}
              style={{
                // padding: "10px 22px 10px 10px",
                // borderRadius: "0px 2px 2px 0px",
                // fontSize: ".875rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "0px 2px 2px 0px",
                fontSize: ".875rem",

              }}
            >
              Search
            </Button>
          </span>
        )}
        {/* {selectionToolbar && selectionToolbar(selectedItems)} */}
      </div>
    );
  };
  const headerSearch = renderHeader();
  // const search = (_row: any) => {
  //   return rowsWithTwoDecimalNumbers && rowsWithTwoDecimalNumbers.filter((rows: any) => rows.employee.toLowerCase().indexOf(itemSearsch.toLowerCase()) > -1)

  //   // || rows.effectiveStartDate.toLowerCase().indexOf(globalFilterValue1)>-1)

  //   // another way where we dont need to write all properties which you want to search (we can search with all props)
  //   // if(rows && rows !== false && _row !== false){
  //   //     const columns = _row[0] && Object.keys(_row[0])

  //   //     return rows.filter((rows:any)=> columns.some((columns:any)=> rows[columns]?.toString().toLowerCase().indexOf(itemSearsch.toLowerCase())>-1))
  //   // }
  // }

  const onPage = (event: any) => {
    // setRequestParams(event);
    setLoading(true);
    //imitate delay of a backend call
    setTimeout(() => {
      setRequestParams({
        ...event,
        searchQuery: itemSearch,
      });
      setLoading(false);
    }, 1000);
  };
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(1);
  const onSort = useCallback(
    (event: any) => {
      setLoading(true);

      let newSortOrder: any;
      if (event.sortField === sortField) {
        // Toggle sortOrder between 1 and -1
        newSortOrder = sortOrder === 1 ? -1 : 1;
        setSortOrder(newSortOrder);
      } else {
        // Set the new sortField and reset sortOrder to 1
        newSortOrder = 1;
        setSortField(event.sortField);
        setSortOrder(newSortOrder);
      }


      setRequestParams((prevParams: any) => ({
        ...prevParams,
        sortOrder: newSortOrder !== 1 ? "asc" : "desc",
        sortField: event.sortField,
      }));

      // Imitate delay of a backend call
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    },
    [sortOrder, sortField]
  );
  // This useEffect is triggered when the debouncedSearchQuery, pageSize or currentPage values change
  useEffect(() => {
    // if the results fetcher was passed, we can use it to fetch the results.
    if (onRequestParamsChange) {
      // skip the first initial call
      if (isInitialRequest.current === true) {

        isInitialRequest.current = false;
      } else {


        onRequestParamsChange(requestParams);
      }
    }
  }, [onRequestParamsChange, requestParams]);

  const rowsWithTwoDecimalNumbers = rows && rows.map((item: any) => ({
    ...item,
    amount: formatAmountCommaSeperator(item.amount),
    accumulatedTotal: formatAmountCommaSeperator(item.accumulatedTotal),
    transactionDate: formatDateToShow(item.transactionDate),
  }));
  const lastRowsWithTwoDecimalNumbers = last_rows && last_rows.map((item: any) => ({
    ...item,
    accumulatedTotal: formatAmountCommaSeperator(item.accumulatedTotal),
  }));



  return (
    <DataTable
      value={rows && rowsWithTwoDecimalNumbers && rowsWithTwoDecimalNumbers}
      responsiveLayout="scroll"
      lazy
      // filterDisplay="row"
      dataKey="id"
      // paginator
      // first={requestParams.first}
      // rows={requestParams.rows}
      // totalRecords={totalRecords && totalRecords}
      // onPage={onPage}
      // onSort={onSort}
      // loading={isLoading ? isLoading : loading}
      // paginator
      // rows={25}
      // rowsPerPageOptions={[25, 50, 100]}
      // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      // currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords && totalRecords
      //   } Items`}
      editMode="row"
      showGridlines
      resizableColumns
      columnResizeMode="expand"
      scrollable
      // scrollHeight={"70vh"}
      // reorderableColumns
      filterDisplay="menu"
      globalFilterFields={["headerName"]}
      // header={headerSearch}
      emptyMessage={rows && rows.length === 0 ? "No Record Found." : "Loading..."}
      className="transactionDetailTableStyle"
      frozenValue={lastRowsWithTwoDecimalNumbers}
      style={{ marginBottom: "3.5rem" }}

    // value={search(rowsWithTwoDecimalNumbers)}
    // responsiveLayout="scroll"
    // paginator
    // rows={25}
    // rowsPerPageOptions={[25, 50, 100, 2]}
    // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
    // currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Transactions"
    // // selection={selectedItems}
    // // onSelectionChange={(e: any) => setSelectedItems(e.value)}
    // // editMode="row"
    // showGridlines
    // resizableColumns
    // columnResizeMode="expand"
    // scrollable
    // // scrollHeight="450px"
    // // reorderableColumns
    // // filterDisplay="menu"
    // loading={isLoading}
    // // globalFilterFields={["headerName"]}
    // header={headerSearch}
    // emptyMessage="No Record found."
    // className="transactionDetailTableStyle"
    // style={{ margin: "0.5rem" }}
    // frozenValue={lastRowsWithTwoDecimalNumbers}
    >
      {columns && rows && (<Column
        selectionMode="multiple"
        hidden={!showChecboxColumn}
        frozen
        resizeable={false}
        style={{ maxWidth: "65px" }}
        field="selection"
        columnKey="selection"
      ></Column>)}

      {rows && rows.length ? (
        <Column
          header="#"
          className="indexColumn"
          headerClassName="indexColumn"
          headerStyle={{ width: "24px" }}
          frozen
          hidden={!showIndexColumn}
          body={(data, options) => options.rowIndex + 1}
        ></Column>
      ) : undefined}
      {columns &&
        columns.map((x: any, index: any) => (
          <Column
            key={index}
            field={x.field}
            header={x.headerName}
            headerTooltip={x.description}
            headerTooltipOptions={{ position: "top" }}
            hidden={x.hide}
            sortable={x.sortable}
            // resizeable={x.resizable}
            dataType={x.type}
            align={x.align}
            alignHeader={x.headerAlign}
            reorderable={x.disableReorder}
            exportable={x.disableExport}
            frozen={x.frozenColumn}
            alignFrozen={x.alignFrozen}
            columnKey={x.field}
            style={{
              minWidth: x.minWidth,
              fontSize: "0.875rem",
            }}
            footer={x.footer}
          />
        ))}

      {/* // <Column
        //   body={delEdit}
        //   header={setting}
        //   style={{ maxWidth: "65px" }}
        //   hidden={!showSettingColumn}
        //   resizeable={false}
        //   reorderable={false}
        //   frozen
        //   alignFrozen="right"
        // ></Column> */}
      <Column
        body={printBody}
        header={setting}
        style={{
          width: "80px"
        }}
        hidden={!showSettingColumn}
        resizeable={false}
        reorderable={false}
        frozen
        alignFrozen="right"
        className="settingHeader"
        headerClassName="settingHeader"
      ></Column>
    </DataTable>
  );
};

//resizeablbe must be false if frozen is true and viseversa
